import AppLayout from '../AppLayout'
import FarmacieSection from './FarmacieSection'

export default function FarmaciePage() {
  return (
    <AppLayout>
      {({ selectedAmbito, onSelectedAmbitoChange }) => (
        <section className="telemetry-dashboard">
          <div className="telemetry-inner">
            <FarmacieSection
              selectedAmbitoId={selectedAmbito}
              onSelectedAmbitoChange={onSelectedAmbitoChange}
            />
          </div>
        </section>
      )}
    </AppLayout>
  )
}
